{
  "common": {
    "productNoun": {
      "form": "form",
      "survey": "survey",
      "quiz": "quiz"
    },
    "productNounCapitalized": {
      "form": "Form",
      "survey": "Survey",
      "quiz": "Quiz"
    },
    "urlField": {
      "settingsTitle": "Define URL field settings",
      "description": "Choose which URL types are allowed for this field.",
      "allowAllDomains": "Allow all domains",
      "allowAllDomainsDescription": "Any valid URL is accepted.",
      "allowOnlyDomains": "Allow only these domains",
      "allowOnlyDomainsDescription": "Everything else is rejected.",
      "blockDomains": "Block these domains",
      "blockDomainsDescription": "Everything else is accepted.",
      "domainsAllowed": "Domains allowed",
      "domainsBlocked": "Domains blocked",
      "domainPlaceholder": "e.g., example.com",
      "domainPlaceholderAdd": "Add another",
      "domainHint": "Type a domain and press Enter to add.",
      "invalidDomain": "Enter a valid domain without http://, https://, or a path.",
      "domainRequired": "Add at least one domain for this option.",
      "singleUrlInfo": "Only one URL is supported per field. To capture multiple URLs, create separate fields."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "seconds",
    "other": "-- Other --",
    "customFieldExistsError": "Custom field with this name already exists",
    "requiredField": "This field is required",
    "uniqueKeyNotUniqueError": "This key is not unique",
    "save": "Save",
    "saving": "Saving",
    "typeAnOption": "Type an Option",
    "unsaved": "Unsaved",
    "noSubmissionsFound": "No Submissions Found",
    "sortBy": "Sort By",
    "clearAll": "Clear all",
    "submitSurvey": "Submit Survey",
    "select": "Select",
    "data": "Data",
    "enterAmount": "Enter amount",
    "disqualifyAfterSubmitLower": "Disqualify after submit",
    "errorRetryAgain": "Error, Retry again",
    "savedSuccessfully": "Saved successfully!",
    "couldntSaveChanges": "Couldn't save changes, please try again.",
    "emailNotificationSettingsUpdated": "Your email notification settings have been updated.",
    "autoResponderSettingsUpdated": "Your auto-responder settings have been updated.",
    "bubbleRadioStyleImageAlt": "Bubble radio style",
    "standardRadioStyleImageAlt": "Standard radio style",
    "recurringFrequency": {
      "once": "Once",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "yearly": "Yearly"
    },
    "saveExitConfirmationSubText": "Show a confirmation modal when the user exits the page.",
    "yes": "Yes",
    "no": "No",
    "updated": "Updated",
    "new": "New",
    "title": "Title",
    "openSettings": "Open settings",
    "cloneField": "Clone field",
    "removeField": "Remove field",
    "description": "Description",
    "cannotAddThisField": "This field can’t be added.",
    "cannotAddThisFieldSubheading": "This {product} already uses {existing} fields. Remove all fields from 1 object before adding {attempted} fields.",
    "overallOnly": "Overall Only",
    "nextSlideDefault": "Next Slide (Default)",
    "nextQuestion": "Next Question",
    "searchAddress": "Search address",
    "recurringDonation": "Recurring Donation",
    "recurringDonationDay": "Recurring Donation 1 day",
    "recurringDonationWeek": "Recurring Donation 1 weekly",
    "recurringDonationMonth": "Recurring Donation 1 month",
    "recurringDonationYear": "Recurring Donation 1 year",
    "integrate": "Integrate",
    "share": "Share",
    "email": "Email",
    "connections": "Connections",
    "comingSoon": "Coming soon",
    "newWorkflow": "New workflow",
    "workflow": "Workflow",
    "funnel": "Funnel",
    "website": "Website",
    "notConnectedToWorkflow": "This {asset} is not connected to workflow yet",
    "workflowEmptyDescription": "Send a confirmation email, notify your team or tag new leads automatically when someone submits this {asset}.",
    "workflowName": "Workflow Name",
    "workflowStatus": "Status",
    "workflowLastUpdated": "Last Updated",
    "workflowStatusPublished": "Published",
    "workflowStatusDraft": "Draft",
    "openInNewTab": "Open in new tab",
    "moreActions": "More actions",
    "rename": "Rename",
    "workflowsShowingFirst": "Showing first {count} workflows",
    "retry": "Retry",
    "workflowsLoadError": "Couldn't load linked workflows.",
    "renameWorkflow": {
      "title": "Rename workflow",
      "description": "Give this workflow a name that tells you what it does.",
      "nameLabel": "Name",
      "namePlaceholder": "Enter workflow name",
      "nameRequired": "Workflow name is required"
    },
    "deleteWorkflow": {
      "title": "Delete workflow",
      "confirmDescription": "Are you sure you want to delete \"{name}\"? Once deleted, it will move to the \"Deleted\" tab and will be permanently removed after 30 days."
    },
    "workflowRenamed": {
      "title": "Workflow renamed",
      "description": "This workflow is now called \"{name}\"."
    },
    "workflowDeleted": {
      "title": "Workflow deleted",
      "description": "\"{name}\" has been deleted."
    },
    "workflowRenameFailed": {
      "title": "Failed to rename workflow",
      "description": "Please try again later."
    },
    "workflowDeleteFailed": {
      "title": "Failed to delete workflow",
      "description": "Please try again later."
    },
    "exampleDomain": "example.com",
    "preview": "Preview",
    "back": "Back",
    "close": "Close",
    "goHighLevel": "GoHighLevel",
    "openMediaLibrary": "Open media library",
    "alert": "Alert",
    "proceed": "Proceed",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "delete": "Delete",
    "embed": "Embed",
    "link": "Link",
    "linkModal": {
      "title": "Insert Link",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.example.com",
      "invalidUrl": "URL is invalid"
    },
    "iframeEmbed": "Iframe Embed",
    "styles": "Styles",
    "options": "Options",
    "quickAdd": "Quick Add",
    "customFields": "Custom Fields",
    "addObjectFields": "Add Object Fields",
    "personalInfo": "Personal Info",
    "contactInfo": "Contact Info",
    "submit": "Submit",
    "address": "Address",
    "customized": "Customized",
    "layout": "Layout",
    "showLabel": "Show Label",
    "showImage": "Show Image",
    "imageLayout": "Image Layout",
    "imageLayoutSettings": "Image Layout Settings",
    "imageLayoutMode": "Image Layout Mode",
    "surveyDefault": "Survey Default",
    "independent": "Independent",
    "image": "Image",
    "desktop": "Desktop",
    "mobile": "Mobile",
    "desktopImage": "Desktop Image",
    "mobileImage": "Mobile Image",
    "uploaded": "Uploaded",
    "changeImage": "Change Image",
    "uploadImage": "Upload Image",
    "remove": "Remove",
    "background": "Background",
    "buttonBackground": "Button Background",
    "gradient": "Gradient",
    "type": "Type",
    "linear": "Linear",
    "radial": "Radial",
    "angular": "Angular",
    "angle": "Angle",
    "stops": "Stops",
    "startColor": "Start Color",
    "endColor": "End Color",
    "addColor": "Add Color",
    "fontColour": "Font Colour",
    "textFontColour": "Text Font Colour",
    "subTextFontColour": "Sub Text Font Colour",
    "selectThemes": "Select Themes",
    "selectOne": "Select one",
    "enableIcon": "Enable Icon",
    "iconType": "Icon Type",
    "iconPlacement": "Icon Placement",
    "filled": "Filled",
    "textOnly": "Text Only",
    "border": "Border",
    "borderType": "Border Type",
    "cornerRadius": "Corner Radius",
    "width": "Width",
    "padding": "Padding",
    "top": "Top",
    "bottom": "Bottom",
    "left": "Left",
    "right": "Right",
    "center": "Center",
    "default": "Default",
    "formDefault": "Form Default",
    "shadow": "Shadow",
    "color": "Color",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Blur",
    "spread": "Spread",
    "fieldStyle": "Field Style",
    "fontColor": "Font Color",
    "inputTextFillColor": "Input Text Fill Color",
    "inputTextColor": "Input Text Color",
    "primaryColor": "Primary Color",
    "primaryColorTooltip": "Controls the color for hover state and active state.",
    "primaryColorTooltipLearnMore": "Learn more",
    "inputTextColorTooltip": "Controls the color of text typed in input fields.",
    "mapPrimaryColorToButtonColor": "Map Primary color to Button color",
    "label": "Label",
    "fontFamily": "Font Family",
    "size": "Size",
    "weight": "Weight",
    "fontWeightTooltip": "Applicable in case of paragraphs",
    "fontWeightOptions": {
      "thin": "100 - Thin",
      "extraLight": "200 - Extra Light",
      "light": "300 - Light",
      "normal": "400 - Normal",
      "medium": "500 - Medium",
      "semiBold": "600 - Semi Bold",
      "bold": "700 - Bold"
    },
    "placeholder": "Placeholder",
    "customCSS": "Custom CSS",
    "backgroundImage": "Background Image",
    "headerImage": "Header Image",
    "miscellaneous": "Miscellaneous",
    "agencyBranding": "Agency Branding",
    "imageUploadMessage": "Click or drag an image file to this area to upload",
    "backgroundImageTooltipMessage": "The background image is intended to cover the entire page, providing a visually appealing backdrop for the form. To view the background image, click on the Preview option.",
    "headerImageTooltipMessage": "The header image is designed to cover the entire width of the form and remains positioned at the top of the form. To view the header image, click on the Preview option.",
    "onSubmit": "On Submit",
    "facebookPixelID": "Facebook Pixel ID",
    "facebookPixelFunnelLabel": "Using this inside a funnel?",
    "facebookPixelFunnelText": "Leave it blank — the funnel's own Pixel and cookie-consent settings take over.",
    "facebookPixelEmbedLabel": "Embedding on another site?",
    "facebookPixelEmbedText": "Choose how cookie consent is handled in the Embed code step.",
    "facebookPixelConsentCallout": "Cookie consent is set per embed, under",
    "facebookPixelConsentCalloutLink": "Integrate → Embed code",
    "facebookPixelEvents": "Facebook Pixel Events",
    "onpageView": "On Page View",
    "stickyContact": "Sticky Contact",
    "stickyContactMessage": "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "generateSubmissionDocument": "Generate submission document",
    "generateSubmissionDocumentMessage": "Automatically create a printable PDF of each submission and attach it to the contact's documents",
    "saveQuizSubmissionAsPdf": "Save quiz submission as PDF",
    "saveQuizResultAsPdf": "Save quiz result as PDF",
    "showSubmissionInConversationsFeed": "Create Conversation on Submission",
    "showSubmissionInConversationsFeedMessage": "Automatically create a conversation thread when this form is submitted, allowing you to follow up via email, SMS, or other channels from the Conversations tab.",
    "fieldDescription": "Field Description",
    "fieldTitle": "Field Title",
    "queryKey": "Query Key",
    "querykeyTooltipMessage": "The query key that can be used as a URL param to populate this field",
    "required": "Required",
    "hidden": "Hidden",
    "hiddenValue": "Hidden value",
    "enableCountryPicker": "Enable Country Picker",
    "altText": "Alt Text",
    "optionImageAlt": "Option image",
    "bannerAlt": "banner",
    "avatarAlt": "Avatar Name",
    "alignment": "Alignment",
    "imageWidth": "Image Width",
    "imageHeight": "Image Height",
    "logic": "Logic",
    "pleaseInput": "Please Input",
    "editHTML": "Edit HTML",
    "textStyle": "Text Style",
    "subText": "Sub Text",
    "text": "Text",
    "buttonStyle": "Button Style",
    "fullWidth": "Full Width",
    "htmlMessage": "The Custom HTML goes here",
    "htmlEditorHeader": "CUSTOM JAVASCRIPT / HTML",
    "htmlEditorBodyMessage": "Add your code here",
    "scriptAdded": "Script Added!",
    "sourceAddedForm": "Source \"Form Name\"",
    "sourceAddedSurvey": "Source \"Survey Name\"",
    "sourceAddedQuiz": "Source \"Quiz Name\"",
    "yesSave": "Yes, Save",
    "cancelKeep": "Cancel, Keep",
    "done": "Done",
    "addElement": "Add Element",
    "addUrlLike": "Please include valid URLs such as",
    "doNotAddRelativePath": "Do not add relative paths like",
    "or": "or",
    "addCustomFields": "Add Custom Fields",
    "customFieldSearch": "Search by name",
    "selectedCount": "{count} selected",
    "noFieldsFound": "No fields found",
    "noFieldsMatchQuery": "No fields match \"{query}\". Try a different term or create a new field.",
    "clearSearch": "Clear search",
    "addFieldWithCount": "Add {count} field | Add {count} fields",
    "noFieldsYet": "No fields yet",
    "noFieldsForObject": "This object doesn't have any fields yet. Create one to get started.",
    "createField": "Create field",
    "enterSourceValue": "Enter Source Value",
    "shortLabel": "Short Label",
    "shortLabelPlaceholder": "Type a short label",
    "labelPlaceholder": "Type a label",
    "imagePlaceholder": "Image",
    "fillValuesPlaceholder": "Add values",
    "customCSSTooltip": "Custom CSS takes precedence over form styling & themes and may have an impact on the theme's styling.",
    "fontFamilyTooltip": "Builder support all type of fonts if you can't see that in the list. Please search it in dropdown",
    "angleTooltip": "Controls the direction of the gradient. 0° is right, 90° is down, 180° is left, 270° is up.",
    "useGDPRCompliantFont": "Use GDPR Compliant Font",
    "enableTimezone": "Enable Timezone",
    "inputStyle": "Input Style",
    "conditionalLogicAlertOnSubmit": "Conditional logic will take precedence over the message / redirect here",
    "conditionalLogicAlertOnShowHide": "Conditional logic will take precedence over the hidden settings here",
    "placeholderFacebookPixelIdInput": "Enter Facebook Pixel ID",
    "doNotShowMessage": "Don't show again",
    "creatingForm": "Creating your form...",
    "creatingSurvey": "Creating your survey...",
    "creatingQuiz": "Creating your quiz...",
    "errorCreatingForm": "There was an error creating your form. Please try again.",
    "errorCreatingSurvey": "There was an error creating your survey. Please try again.",
    "errorCreatingQuiz": "There was an error creating your quiz. Please try again.",
    "redirectMessage": "You will be redirected to:",
    "themes": {
      "themes": "Themes",
      "alertThemeMessage": "Switching themes will result in the loss of all the current style modifications.",
      "useTheme": "Use theme",
      "removeTheme": "Remove theme"
    },
    "box": "Box",
    "line": "Line",
    "message": "Message",
    "openUrl": "Redirect to URL",
    "borderTypeList": {
      "dotted": "Dotted",
      "dashed": "Dashed",
      "solid": "Solid",
      "none": "None"
    },
    "button": "Button",
    "emailNotification": "Email notification",
    "emailNotificationSubheader": "Receive an email when someone fills out your form",
    "subject": "Subject",
    "emailTo": "Email (To)",
    "senderName": "Sender name",
    "senderNameWarning": "Your (sub-account name) will be added if left blank",
    "emailError": "At least one email address is required",
    "emailTooltip": "Enter one or more email addresses that should receive this form-submission alert. The first address goes in 'To'; additional ones are treated as 'CC'.",
    "emailTooltipForm": "Enter one or more email addresses that should receive this form-submission alert. The first address goes in 'To'; additional ones are treated as 'CC'.",
    "emailTooltipSurvey": "Enter one or more email addresses that should receive this survey-submission alert. The first address goes in 'To'; additional ones are treated as 'CC'.",
    "emailTooltipQuiz": "Enter one or more email addresses that should receive this quiz-submission alert. The first address goes in 'To'; additional ones are treated as 'CC'.",
    "clear": "Clear",
    "filter": "Filter",
    "noResults": "No results",
    "search": "Search",
    "showNotificationsSettings": "Show Notifications Settings",
    "emailServicePaid": "This feature is a paid service and will incur charges based on your usage.",
    "integration": "Integration",
    "validation": {
      "fieldRequired": "Field is required",
      "maxLengthExceeded": "Maximum length exceeded ({max} characters)"
    },
    "securityValidation": {
      "title": "Security issues detected. The following are not allowed:",
      "cookieAccess": "Cookie access detected (document.cookie). This is not allowed for security reasons.",
      "storageAccess": "localStorage.getItem() - reading from localStorage is not allowed.",
      "evalUsage": "Use of eval() is not allowed as it can execute arbitrary code.",
      "dynamicFunction": "Dynamic function creation (new Function) is not allowed for security reasons.",
      "stringExecution": "Passing strings to setTimeout/setInterval is not allowed as it can execute arbitrary code. Use function references instead.",
      "unclosedTag": "Unclosed HTML tag detected (for example a <style> without a closing </style>). Please close all tags before saving, otherwise the published page may fail to load."
    },
    "products": {
      "subscriptionBadge": "Subscription",
      "trialBadge": "{days} Day Free Trial",
      "setupFee": "One Time Setup fee",
      "quantity": "Quantity",
      "productImageAlt": "Product image",
      "bumpIconAlt": "Bump icon"
    },
    "payment": {
      "payments": "Payments",
      "paymentProviders": "Payment providers",
      "paymentProvidersDescription": "Connect a payment provider to start accepting payments.",
      "connectedProviders": "Connected providers",
      "requireCreditCard": "Require card for $0 orders",
      "requireCreditCardTooltip": "When enabled, customers must enter a credit card even for $0 purchases.",
      "connectProviders": "Connect providers",
      "loading": "Loading...",
      "generalTab": "General",
      "productTab": "Product",
      "connected": "Connected",
      "connect": "Connect",
      "liveModeOn": "Live mode",
      "status": "Status",
      "test": "Test",
      "live": "Live",
      "paymentFields": "Payment Fields",
      "suggestAnAmount": "Suggest an amount",
      "recurringPayments": "Recurring Payments",
      "selectCurrency": "Select Currency",
      "tagActiveBGColor": "Active Tag Color",
      "includeOtherAmount": "Include other amount",
      "footerInfo": "Footer Info",
      "paymentType": "Payment Type",
      "sellProducts": "Sell Products",
      "customAmount": "Custom Amount",
      "collectPayment": "Collect Payment",
      "generalSettings": "General fields",
      "securePayments": "*100% secure & safe payments*",
      "error": {
        "addMainProductFirst": "Add a main product first",
        "priceNotFoundForBumpProduct": "Price not found for Bump Product",
        "productAlreadyAdded": "Product already added"
      },
      "product": {
        "addProduct": "Add Product",
        "productSettings": "Product Settings",
        "bumpTag": "Bump",
        "settingsAria": "Product settings",
        "deleteAria": "Delete product",
        "selectProduct": "Select Product",
        "editThisProduct": "To edit this product",
        "clickHere": "Click here",
        "show": "Show",
        "description": "Description",
        "image": "Image",
        "layoutSettings": "Layout settings",
        "singleColumn": "Single Column",
        "twoColumn": "Two Column",
        "threeColumn": "Three Column",
        "maxProductError": "Maximum 20 products are allowed in a form",
        "productSelectPlaceholder": "Please select a product",
        "orderConfirmation": "Order Confirmation",
        "orderConfirmationWarning": "Order confirmation page will be shown once payment is successful",
        "quantity": "Quantity",
        "createProduct": "To create a product",
        "noProductsAdded": "No products added yet",
        "productsWillShowHere": "Once you add products, they'll show up right here",
        "chooseProductType": "Choose Product Type",
        "mainProduct": "Main Product",
        "primaryOffer": "Primary offer",
        "checkoutAddOn": "Checkout add-on",
        "pricingOptions": "Pricing options",
        "pricingOptionsPlaceholder": "Select pricing options (default: all)",
        "all": "ALL",
        "addOrSelectProducts": "Add or select products",
        "onceYouAddProductsTheyWillShowUpRightHere": "Once you add products, they'll show up right here",
        "addProducts": "Add Products"
      },
      "bumProduct": {
        "price": "Price",
        "variant": "Variant",
        "headline": "Headline",
        "otoHeadline": "OTO Headline",
        "otoText": "OTO Text",
        "enableImage": "Enable Image",
        "imageMessage": "We'll grab the default product image",
        "orUploadADifferentImage": "Or upload a different image",
        "bumpProducts": "Bump Products",
        "bumpProduct": "Bump Product",
        "enableBump": "Enable Bump",
        "orderBumpStyle": "Order Bump Style",
        "classic": "Classic",
        "modern": "Modern",
        "icon": "Icon",
        "bumpTemplate": "Select Template",
        "highlightText": "Highlight Text",
        "showPrice": "Show Price",
        "bumpPriceColor": "Bump Price",
        "bumpIconColor": "Bump Icon",
        "bumpBackgroundColor": "Bump Background",
        "highlightTextColor": "Highlight Text",
        "headlineColor": "Headline",
        "otoHeadlineColor": "OTO Headline",
        "otoTextColor": "OTO Text",
        "bumpBorderColor": "Bump Border",
        "priceRequired": "Price is required",
        "headlineRequired": "Headline is required",
        "otoHeadlineRequired": "OTO Headline is required",
        "otoTextRequired": "OTO Text is required",
        "bumpProductTooltip": "A small add-on offered during checkout to boost order value. Customers can add it with a single click.",
        "templateOne": "Template 1",
        "templateTwo": "Template 2",
        "templateThree": "Template 3",
        "animationIcon": {
          "none": "None",
          "arrow": "Arrow",
          "fire": "Fire",
          "plus": "Plus",
          "giftBox": "Gift Box",
          "timer": "Timer",
          "cracker": "Cracker",
          "snack": "Snack",
          "partyBalloon": "Party Balloon",
          "flash": "Flash",
          "money": "Money",
          "spaceShuttle": "Space Shuttle"
        }
      },
      "coupons": {
        "coupons": "Coupons",
        "enableCoupon": "Enable Coupon",
        "couponAlignment": "Coupon Alignment",
        "left": "Left",
        "right": "Right",
        "fullWidth": "Full Width",
        "tooltipMessage": "Set the position of coupon input from below types"
      }
    },
    "sellProductsAddress": {
      "shippingAddressDescription": "Uses the Address element to calculate tax based on the customer's address.",
      "billingAddress": "Billing Address",
      "billingRequiresAddress": "Add an Address element to enable Billing Address. Billing uses its address fields.",
      "billingSameAsShipping": "Billing address same as shipping address",
      "phoneNumber": "Phone Number",
      "billingAddressEnableFailed": "We couldn't enable Billing Address fields. Please try saving again."
    },
    "addressSettings": {
      "autoComplete": "Auto-Complete Address",
      "addressfields": "Address Fields",
      "placeholderSearch": "Search for an address",
      "autoCompleteTooltip": "Provides ability to search and automatically populate address.",
      "streetAddress": "Street Address",
      "autoCompleteAddressTitle": "Auto Complete Address",
      "newBadge": "New",
      "defaultLabel": "Address",
      "searchPlaceholder": "Search address",
      "mandataorySearch": {
        "title": "Mandatory to Select Address in Search Bar",
        "primaryText": "Auto-complete only for Street Address",
        "secondaryText": "When enabled, whenever a user interacts with the address field, then they must select a valid address to proceed.",
        "secondaryText1": "When Disabled then they can proceed without selecting an address in search bar."
      }
    },
    "autoResponder": "Auto responder",
    "workflow": "Workflow",
    "workflowSubheader": "Automate what happens after a form is submitted",
    "workflowTitle": "Create your own simple workflow.",
    "workflowDescription": "Use workflows to take care of your follow-ups after contacts engage with your form. For example, sending them a follow-up email or sms",
    "createWorkflow": "Create Workflow",
    "workflowVisualAlt": "Workflow visual",
    "autoResponderSubheader": "Send an automated email to the person who submits the form (email includes a copy of the information they entered in the form)",
    "replyToEmail": "Reply-to-email",
    "open": "Open",
    "won": "Won",
    "lost": "Lost",
    "abandon": "Abandon",
    "selectAPipeline": "Select a pipeline",
    "stage": "Stage",
    "status": "Status",
    "opportunityValue": "Opportunity value",
    "createNewPipeline": "Create new pipeline",
    "editOpportunitySettings": "Edit Opportunity Settings",
    "contact": "Contact",
    "opportunity": "Opportunity",
    "business": "Company",
    "add": "Add",
    "manage": "Manage",
    "more": "More",
    "opportunityHeading": "Where do you want your opportunity to be updated?",
    "date": {
      "dateSettings": "Date Settings",
      "dateFormat": "Date Format",
      "dateSeparator": "Date Separator",
      "dateFormatTooltipMessage": "Select a date format. D stands for day, M for months, and Y for year",
      "dateSeparatorTooltipMessage": "Select a separator which will separate day, month, and year in format selected on Date Format",
      "disablePicker": "Disable Picker"
    },
    "dateTime": {
      "tabGeneral": "General",
      "tabFieldSettings": "Field settings",
      "collectHeading": "Select what this field should collect",
      "collectDate": "Date",
      "collectTime": "Time",
      "collectDateTime": "Date & time",
      "collectTypeLockedTooltip": "The collect type can only be changed before the field is saved",
      "placeholderTextPlaceholder": "Add placeholder text",
      "shortLabelPlaceholder": "Add short label",
      "fieldSettingsBanner": "Define the allowed date or time range, restrict which days users can pick, and choose how the value is displayed.",
      "allowedDateRange": "Allowed date range",
      "dateModeAny": "Any date",
      "dateModeFuture": "Future dates only",
      "dateModePast": "Past dates only",
      "dateModeRange": "Specific date range",
      "futureQuestion": "What dates can users choose?",
      "futureAny": "Any future date",
      "futureAnyDesc": "Users can choose any date after the current date. E.g., Book a meeting anytime next year.",
      "futureBuffer": "After buffer time",
      "futureBufferDesc": "Users can only choose dates after a set number of days. E.g., Allow bookings 3 days from today.",
      "futureBufferSuffix": "days from today",
      "futureRolling": "Within a set date range",
      "futureRollingDesc": "Users can choose dates within a defined future range. E.g., Allow bookings within the next 30 days.",
      "futureRollingPrefix": "Next",
      "futureRollingSuffix": "days",
      "rangeLabel": "Specific date range",
      "rangeStart": "Start date",
      "rangeEnd": "End date",
      "availableDays": "Available days",
      "allowedTimeRange": "Allowed time range",
      "timeModeAny": "Any time",
      "timeModeRange": "Specific time range",
      "timeRangeLabel": "Specific time range",
      "timeStart": "Start time",
      "timeEnd": "End time",
      "timeFormatLabel": "Time format",
      "timeFormat24": "24 hour",
      "timeFormat12": "AM / PM",
      "timePlaceholder": "HH:MM",
      "defaultTimeLabel": "Default time",
      "defaultTimeHelper": "Pre-populate with a current or custom time.",
      "defaultTimeNone": "None",
      "defaultTimeCurrent": "Current",
      "defaultTimeCustom": "Custom",
      "customTimeLabel": "Custom time",
      "customTimeError": "Enter a valid time in HH:MM format",
      "disableCalendarPopup": "Disable calendar popup",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Select at least one available day",
      "dateRangeError": "End date must be on or after the start date",
      "timeRangeError": "End time must be after the start time",
      "saveBlockedTitle": "Date & time field is incomplete",
      "saveBlockedDescription": "Fix the highlighted date & time validation errors before saving.",
      "weekday": {
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun"
      }
    },
    "restoreVersion": "Restore Version",
    "versionHistory": "Version History",
    "versionPreviewTitle": "Version preview",
    "errorMessage": "Error, Retry again",
    "version": "Version:",
    "currentVersion": "Current Version",
    "messageStyling": "Message Styling",
    "validateEmailHeader": "Validate Email",
    "validateEmailDescription": "The button will become visible once the user enters their email. This feature is designed to help you generate quality leads.",
    "verifyEmail": "Verify Email",
    "validatePhoneHeader": "Validate Phone",
    "validatePhoneDescription": "The button will become visible once the user enters their phone. This feature is designed to help you generate quality leads.",
    "verifyPhone": "Verify Phone",
    "validatePhoneWarning": "To enable SMS OTP verification, please ensure your phone number is set up in your location settings",
    "addAnotherTnc": "Add another T & C",
    "tnc1": "T & C 1",
    "tnc2": "T & C 2",
    "deleteCaps": "DELETE",
    "deleteConfirmation": "Type DELETE to confirm",
    "marginPadding": "Margin & Padding",
    "style": {
      "formLayoutType": "Form Type",
      "layoutType": "Layout Type",
      "surveyType": "Survey Type",
      "oneColumn": "One Column",
      "twoColumn": "Two Column",
      "singleLine": "Single Line",
      "fieldWidth": "Field Width",
      "labelAlignment": {
        "labelAlignment": "Label Alignment",
        "labelWidth": "Label Width"
      },
      "fieldSpacing": "Field Spacing",
      "imageFieldSpacing": "Image & Field Spacing",
      "imageCornerRadius": "Image Corner Radius",
      "color": "color",
      "fontColor": "Font color",
      "inputBackgroundColor": "Input Background Color",
      "inputBorder": "Input Border",
      "layout": "Layout",
      "colorsAndBackground": "Colors & Background",
      "imageLayout": {
        "imageLayout": "Image Layout",
        "showImage": "Show Image",
        "image": "Image",
        "desktop": {
          "topFixed": "Top Fixed",
          "leftCenter": "Left Center",
          "rightCenter": "Right Center",
          "leftFixed": "Left Fixed",
          "rightFixed": "Right Fixed",
          "background": "Background"
        },
        "mobile": {
          "header": "Header",
          "background": "Background"
        }
      },
      "focusPoint": {
        "title": "Focal Point",
        "reset": "Reset",
        "noImage": "No image uploaded"
      },
      "advanceSettings": "Advanced Settings",
      "inputField": "Input Field",
      "borderWidth": "Border Width",
      "borderColor": "Border Color",
      "borderStyle": "Border Style",
      "fontSize": "Font Size",
      "fontWeight": "Font Weight",
      "labelColor": "Label Color",
      "placeholderColor": "Placeholder Color",
      "shortLabelColor": "Short Label Color"
    },
    "replyToTooltip": "Specify the email address where replies to this notification should go. Use {'{'}{'{'}contact.email{'}'}{'}'} to let recipients reply directly to the person who filled out the form.",
    "content": "Content",
    "calculations": "Calculations",
    "uploadOptions": "Upload options",
    "opportunitySettingsWarning": "Please set up opportunity settings by clicking on the Edit Opportunity Settings button.",
    "startValue": "Start Value",
    "endValue": "End Value",
    "today": "Today",
    "thisWeek": "This week",
    "last7Days": "Last 7 days",
    "thisMonth": "This month",
    "last30Days": "Last 30 days",
    "question": "Question",
    "createContactOnPartialSubmission": "Create Contact on Partial Submission",
    "howItWorks": "How it works?",
    "createContactOnPartialSubmissionDescription": "Finish the slide and click \"Next\". A new contact will automatically created and stored.",
    "swapWarningMessageSurvey": "Editing or swapping options will impact this custom field across all places where the field is used. It can also reset conditional logic. ",
    "swapWarningMessageForm": "Editing or swapping options will impact this custom field across all places where the field is used. ",
    "migrationWarningMessage": "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel": "Option label",
    "calculationValue": "Calculation value",
    "addOption": "Add option",
    "addOtherOption": "Add \"Other\" option",
    "otherOptionLabel": "Other",
    "otherOptionPlaceholder": "Please type another option here",
    "enableCalculations": "Enable calculations",
    "allowOtherOption": "Allow other option",
    "productSelectionSubtext": "Allow single or multiple product selection",
    "multi": "Multi",
    "single": "Single",
    "productSelectionHeading": "Product Selection",
    "spreadToColumns": "Spread to columns",
    "columns": "Columns",
    "customstyle": "Style",
    "standard": "Standard",
    "bubble": "Bubble",
    "radioStyles": {
      "standardAlt": "Standard radio style",
      "bubbleAlt": "Bubble radio style"
    },
    "integratePopup": {
      "title": "Integrate Form",
      "embedCode": "Embed Code",
      "useInFunnelOrEmbedCode": "Use in Funnel/ Embed Code",
      "iframeEmbed": "Iframe Embed",
      "layout": {
        "title": "Embed layout type",
        "description": "Select a layout to embed in a funnel or an external website",
        "allowMinimize": "Allow minimize",
        "minimizedTitlePlaceholder": "Minimized title",
        "leftAlignAlt": "Left align",
        "rightAlignAlt": "Right align"
      },
      "triggerType": "Trigger type",
      "triggers": {
        "seconds": "seconds"
      },
      "activation": {
        "title": "Activation options",
        "visit": "visit"
      },
      "deactivation": {
        "title": "Deactivation options",
        "times": "times"
      },
      "copyEmbedCode": "Copy embed code",
      "copyFormLink": "Copy form link",
      "openFormLink": "Open form link",
      "invalidInput": "Invalid input!",
      "funnel": {
        "funnel": "Funnel",
        "chooseStep": "Choose a step",
        "copyCodeAndOpenFunnel": "Copy Code & Open Funnel"
      },
      "share": {
        "share": "Share",
        "shareViaSocials": "Share via Socials",
        "copyLink": "Copy Link"
      },
      "email": {
        "email": "Email",
        "shareViaEmail": "Share via Email",
        "emailButton": "Email",
        "blankTemplate": "Blank Template",
        "emailMarketingTemplates": "Email Marketing Templates",
        "or": "Or",
        "chooseTemplate": "Choose from your templates",
        "continue": "Continue"
      }
    },
    "rating": {
      "icon": "Icon",
      "iconAlignment": "Icon Alignment",
      "count": "Count",
      "lowestRating": "Lowest Rating",
      "highestRating": "Highest Rating",
      "iconSelectedState": "Icon Selected State",
      "iconUnselectedState": "Icon Unselected State",
      "rating": "Rating",
      "ratingSettings": "Rating Settings",
      "calculationType": {
        "calculationType": "How to Store Rating Fields in Custom Fields",
        "calculationTypeTooltip": "When you rate something 4 out of 5 stars, it means:\n- Absolute: 4 out of 5\n- Percentage: 80\n- Fraction: 0.8",
        "absolute": "Absolute",
        "percentage": "Percentage",
        "fraction": "Fraction"
      }
    },
    "desktopMode": "Desktop Mode",
    "mobileMode": "Mobile Mode",
    "versions": "Versions",
    "advanced": "Advanced",
    "edit": "Edit",
    "settings": "Settings",
    "submissions": "Submissions",
    "analytics": "Analytics",
    "notifications": "Notifications",
    "undo": "Undo",
    "redo": "Redo",
    "customValues": "Custom Values",
    "pickBgFromImage": "Adds a blur to the background of your message box. If you choose a background color for message box, it appears over the blurred message box.",
    "pickBgFromImageTip": "Picks a color with high contrast for the BG Image. Note: Will not be applied if the Form background has no Image",
    "messageBackgroundBlur": "Background Blur",
    "confirmationMessage": "Confirmation Message",
    "deleteOption": "Delete Option",
    "deleteConfirmationModal": {
      "defaultDescription": "Deleting an option will impact this custom field across all places where the field is used. Are you sure you wish to delete it?",
      "validationMessage": "Please enter DELETE to confirm.",
      "validationError": "Please enter DELETE"
    },
    "disqualifyImmediately": "Disqualify Immediately",
    "disqualifyAfterSubmit": "Disqualify After Submit",
    "generalSettings": "General Settings",
    "advancedSettings": "Advanced Settings",
    "customFieldName": "Custom Field Name",
    "customFieldNameTooltip": "This field name is unique for each custom field.",
    "customFieldNameTooltipContact": "These fields allow users to capture additional details about a person, such as their lead type, birthday, or preferred method of contact.",
    "customFieldNameTooltipContactLearnMore": "Learn more",
    "customFieldNameTooltipOpportunity": "These fields are used to track deal-specific data for each opportunity, including information like the budget or a closing target.",
    "customFieldNameTooltipOpportunityLearnMore": "Learn more",
    "customFieldNameTooltipCompany": "These fields enable the capture of organization-level information (e.g., for vendors, clients, or agencies) that is linked to contacts.",
    "customFieldNameTooltipCompanyLearnMore": "Learn more",
    "customFieldNameTooltipCustomObject": "These fields allow users to collect business-specific data, such as details about assets, vehicles, or properties, and integrate this information into their CRM system.",
    "customFieldNameTooltipCustomObjectLearnMore": "Learn more",
    "uniqueKey": "Unique Key",
    "uniqueKeyTooltip": "This key is the system-identifier for the custom field. Once set, it cannot be changed.",
    "uniqueKeyTooltipLearnMore": "Learn more",
    "selectContactAssociation": "Select the association with Contacts",
    "selectObjectAssociation": "Select the association between {objectA} and {objectB}",
    "pickHowRecordsLink": "Both objects are on this form, so the submission needs to know how they relate.",
    "association": "Association",
    "newAssociationBetween": "New association between {objectA} and {objectB}",
    "opportunitySetupTitle": "Set up this opportunity",
    "opportunitySetupSubtitle": "Pick where it lands.",
    "opportunitySetupSubtitleLinked": "Pick where it lands, and how it links to {object}.",
    "opportunityPlacement": "Opportunity placement",
    "newPipeline": "New pipeline",
    "associations": "Associations",
    "createNewAssociation": "Create new association",
    "selectAnAssociation": "Select an association",
    "loadingAssociations": "Loading associations...",
    "unknownAssociation": "Unknown Association",
    "manyToMany": "Many to Many",
    "failedToLoadAssociations": "Failed to load associations",
    "noAssociationsFound": "No associations found",
    "keepThisField": "Keep this field",
    "customObject": "Custom Object",
    "customObjects": "Custom Objects",
    "object": "Object",
    "editAssociation": "Edit {objectName} Association",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Fields",
    "primaryFieldWarning": "{fieldName} is a primary field for {objectSingular} and is required to create or update a {objectSingular}.",
    "primaryFieldTitle": "{fieldName} is required to create or update {objectSingular} record.",
    "removeAllFields": "Remove all {objectSingular} Fields",
    "customObjectsFallback": "Custom Objects",
    "noneAssociation": "None",
    "noneAssociationDescription": "No association with contacts (no contact fields present)",
    "survey": {
      "layoutType": "Survey Type",
      "oneQuestionPerPage": "One Question at a Time",
      "allQuestionsOnePage": "Many at a Time"
    },
    "quizQuestions": "Quiz Questions",
    "choiceElements": "Choice Elements",
    "otherElements": "Other Elements",
    "listEditor": {
      "prefillValueHeader": "Prefill Value",
      "labelPlaceholder": "Label",
      "valuePlaceholder": "Value",
      "optionRequiredError": "The option field is required"
    },
    "field": "Field",
    "scoreEditor": {
      "addFieldPlaceholder": "Add Field",
      "fieldLabel": "Field",
      "numberLabel": "Number"
    },
    "fileUploadEditor": {
      "fileTypes": "File types",
      "all": "All",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV",
      "fileAccess": "File access",
      "fileAccessDescription": "Choose who can access files uploaded to this field. This setting can't be changed after the field is created.",
      "fileAccessLocked": "Once the field is created, its file access setting cannot be changed.",
      "privateFiles": "Private files",
      "privateFilesTooltip": "Only authorized users can view and download files.",
      "publicFiles": "Public files",
      "publicFilesTooltip": "Anyone with the file link can view and download files."
    },
    "ok": "Ok",
    "allowMultipleFiles": "Allow multiple files",
    "maxFileLimit": "Max file limit",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "colorPicker": {
      "brandColors": "Brand Colors",
      "defaultColors": "Default Colors",
      "globalCustomColors": "Global Custom Colors"
    },
    "billingFrequency": "Billing Frequency",
    "otherAmount": "Other amount",
    "exampleUrlPlaceholder": "https://www.example.com",
    "checkboxStyles": {
      "standardAlt": "Standard checkbox style",
      "bubbleAlt": "Bubble checkbox style"
    },
    "previewIcons": {
      "exportAlt": "Export icon",
      "shipmentAlt": "Shipment icon",
      "resultAlt": "Result page icon"
    },
    "examples": {
      "sampleUrl": "https://example.com"
    },
    "showing": "Showing",
    "of": "of",
    "enterCouponCode": "Enter coupon code",
    "apply": "Apply",
    "paymentWillBeProcessed": "Payment will be processed as soon as you proceed to the next step",
    "paymentWillBeProcessedNextSlide": "Payment will be processed as soon as user proceeds to the next slide",
    "showThisAlertToUsers": "Show This Alert to Users",
    "sixteenDigitCardNumber": "16 digit card number",
    "mmYy": "MM / YY",
    "cvc": "CVC",
    "threeDigitCode": "3-digit code",
    "enterCardNumber": "Enter card number",
    "pleaseFillRequiredFields": "Please fill all the required fields!",
    "opportunitySettingsIncomplete": "Opportunity settings incomplete",
    "opportunitySettingsIncompleteDescription": "This form includes Opportunity fields, but the Opportunity settings have not been updated. Please configure the Opportunity settings to proceed with saving the form.",
    "ariaAttributes": {
      "iconSearch": "Icon search"
    },
    "alt": {
      "standardRadioStyle": "Standard radio style",
      "bubbleRadioStyle": "Bubble radio style"
    },
    "value": "Value",
    "jumpTo": "Jump to",
    "thankYouJohnDoe": "Thank you, John Doe",
    "total": "Total",
    "urlExamples": {
      "simple": "example.com",
      "https": "https://example.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Thank you for taking the time to complete this quiz."
  },
  "overallScore": {
    "defaultTitle": "Overall score"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Single Choice",
      "multipleChoice": "Multiple Choice",
      "yesNo": "Yes / No",
      "shortAnswer": "Short Answer",
      "longAnswer": "Long Answer",
      "number": "Number",
      "singleDropdown": "Single Dropdown",
      "multiDropdown": "Multi Dropdown"
    },
    "personal": {
      "fullName": "Full Name",
      "firstName": "First Name",
      "lastName": "Last Name",
      "dateOfBirth": "Date of birth",
      "phone": "Phone",
      "email": "Email",
      "fullNamePlaceholder": "Enter your full name",
      "firstNamePlaceholder": "Enter your first name",
      "lastNamePlaceholder": "Enter your last name",
      "dateOfBirthPlaceholder": "DD / MM / YYYY",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Button"
    },
    "integration": {
      "sellProducts": "Sell Products",
      "collectPayment": "Collect Payment"
    },
    "address": {
      "address": "Address",
      "streetAddress": "Street Address",
      "city": "City",
      "state": "State",
      "country": "Country",
      "postalCode": "Postal Code",
      "organization": "Organization",
      "website": "Website",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Street Address",
      "streetAddressPlaceholder": "Enter your full address",
      "cityPlaceholder": "Enter your city",
      "statePlaceholder": "Enter your state",
      "countryPlaceholder": "Enter your country",
      "postalCodePlaceholder": "ZIP or postal code",
      "organizationPlaceholder": "Enter your organization"
    },
    "text": {
      "singleLine": "Single Line",
      "multiLine": "Multi Line",
      "textBoxList": "Text Box List",
      "singleLinePlaceholder": "Enter your text",
      "multiLinePlaceholder": "Type your message here"
    },
    "choiceElements": {
      "singleDropdown": "Single Dropdown",
      "multiDropdown": "Multi Dropdown",
      "checkbox": "Checkbox",
      "radio": "Radio",
      "singleDropdownPlaceholder": "Select an option",
      "multiDropdownPlaceholder": "Choose one or more options",
      "pictureChoice": {
        "label": "Picture Choice",
        "multipleSelection": "Multiple selection",
        "selectionTypeLocked": "Selection type cannot be changed after this custom field is saved.",
        "imageRequiredBeforeSave": "Every option in a Picture Choice element must have an image.",
        "labelRequiredBeforeSave": "Every option in a Picture Choice element must have a label.",
        "duplicateOptionLabelsBeforeSave": "Every option in a Picture Choice element must have a unique label.",
        "selectionLimitInvalidBeforeSave": "Enter a valid selection limit for the Picture Choice element.",
        "selectionLimit": "Selection limit",
        "unlimited": "Unlimited",
        "exact": "Exact",
        "range": "Range",
        "exactSelections": "Exact selections",
        "minimum": "Minimum",
        "maximum": "Maximum",
        "options": "Options",
        "optionSettings": "Option settings",
        "showOptionLabel": "Show option label",
        "addOption": "Add option",
        "otherOption": "Other option",
        "imageFit": "Image fit",
        "cover": "Cover",
        "contain": "Contain",
        "fill": "Fill",
        "spreadToColumns": "Spread to Columns",
        "columns": "Columns",
        "numberOfColumns": "Number of columns",
        "desktopColumnsLimit": "Maximum {count} columns on desktop.",
        "mobileColumnsLimit": "Maximum {count} columns on mobile.",
        "otherOptionLabel": "Other option label",
        "optionLabel": "Option label",
        "image": "Image",
        "media": "Media",
        "otherImageUploadUnavailable": "An image cannot be uploaded for the Other option.",
        "removeImage": "Remove image",
        "deleteOption": "Delete option",
        "altText": "Alt text"
      }
    },
    "customized": {
      "text": "Text",
      "html": "Html",
      "htmlPlaceholder": "The Custom HTML goes here",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Challenge",
      "botProtection": "Bot protection",
      "verificationMode": "Verification Mode",
      "interactive": "Interactive",
      "invisible": "Invisible",
      "invisibleModeDescription": "This verification runs automatically in the background and won't be visible to users",
      "fieldHiddenWarning": "This field is hidden and will not be seen on the form.",
      "verifyHuman": "Verify you are human",
      "privacy": "Privacy",
      "help": "Help",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Source",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "I agree to terms & conditions provided by the company. By providing my phone number, I agree to receive text messages from the business.",
      "score": "Score",
      "scorePlaceholder": "Ex: Your Score is 100%"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Enter a URL",
      "image": "Image",
      "fileUpload": "File Upload",
      "monetary": "Monetary",
      "number": "Number",
      "datePicker": "Date & time",
      "datePickerLegacy": "Date Picker",
      "datePickerGeneratedName": "Date",
      "timePickerGeneratedName": "Time",
      "dateTimePickerGeneratedName": "Date & time",
      "signature": "Signature",
      "monetaryPlaceholder": "Enter amount",
      "signaturePlaceholder": "Sign here",
      "numberPlaceholder": "Enter a number",
      "datePickerPlaceholder": "DD / MM / YYYY",
      "imageUploadPlaceholder": "No Image added yet",
      "imageUploadSubText": "Upload to Media Storage or drag and drop",
      "imageUploadButtonText": "Upload Image",
      "fileText": "File",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Click to upload"
    },
    "customstyle": "Style",
    "standard": "Standard",
    "bubble": "Bubble"
  },
  "survey": {
    "addSlideText": "Add Elements",
    "defaultScreenTitle": "Drag and drop components",
    "defaultScreenDescription": "Move your question to the {pageIndex} page using the elements on the left.",
    "typeOfBuilder": "Survey",
    "survyeStyle": "Survey Style",
    "surveyName": "Survey Name",
    "surveyElement": "Survey Element",
    "addSurveyElement": "Add Survey Element",
    "cloneSlide": "Clone Slide",
    "unsavedAlertMessage": "The survey has unsaved work. Are you sure you want to leave and discard all unsaved work?",
    "thirdPartyScriptAlertMessage": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security, performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the survey.",
    "integrateHeader": "Integrate Survey",
    "integrateSubHeader": "Use the following options to integrate your custom survey into your website",
    "integrateCopyLinkMessage": "Copy the link below and easily share it anywhere you wish.",
    "onSurveySubmission": "On Survey Submission",
    "saveExitConfirmation": "Save progress for surveys",
    "surveySettings": "Survey Settings",
    "oneQuestionAtTime": "One question at a time",
    "backButton": "Back Button",
    "backButtonTooltipMessage": "Back button will help users to move to the previous slide",
    "disableAutoNavigation": "Disable Auto Navigation",
    "disableAutoNavigationTooltipMessage": "Automatically navigates to the next slide after a user responds.",
    "autoNavigation": "Auto Navigation",
    "autoNavigationTooltipMessage": "Automatically navigates to the next slide after a user responds.",
    "progressBar": "Progress Bar",
    "progressBarTooltipMessage": "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation": "Disable Animation",
    "disableAnimationTooltipMessage": "Turning this on will disable the slide transition animation",
    "scrollToTop": "Scroll to Top",
    "scrollToTopTooltipMessage": "If turned on, the survey will scroll to top on the next slide",
    "submitSurvey": "Submit Survey",
    "disqualifyImmediately": "Disqualify immediately",
    "disqualifyAfterSubmit": "Disqualify After Submit",
    "disqualifyAfterSubmitLowerCase": "Disqualify after submit",
    "footerHTML": "Footer HTML",
    "footerHTMLMessage": "You can write custom CSS (using style tag) and HTML inside the same box",
    "editFooter": "Edit Footer",
    "disqualifySettings": "Disqualify Settings",
    "disqualifyImmediatelyLabel": "Immediately",
    "disqualifyAfterSubmitLabel": "After Submit",
    "slideConflictAlertMessage": "This slide contains multiple questions that have a logic set to them. This can cause some unintended behavior",
    "addSlide": "Add Slide",
    "settings": "Settings",
    "delete": "Delete",
    "slideDeleteAlertMessage": "Are you sure you want to delete this slide?",
    "slideDeleteBetweenAlertMessage": "This will rearrange the other slides, are you sure you want to delete this slide?",
    "slideLabel": "Slide {n}",
    "slideName": "Slide Name",
    "slidePosition": "Slide Position",
    "jumpTo": "Jump To",
    "jumpToSubText": "Jump to a specific slide",
    "enableTimezoneSurvey": "Activating this option will capture the time zone information of the individual submitting the survey",
    "footer": {
      "footer": "Footer",
      "enableNewFooter": "Enable New Footer",
      "stickToSurvey": " Stick to Survey",
      "backgroundFill": "Background Fill",
      "footerHeight": "Footer Height",
      "enableProgressBar": "Enable Progress Bar",
      "buttons": "Buttons",
      "button": "Button",
      "buttonType": "Button Type",
      "buttonTypeTooltip": "Choose how the navigation buttons appear on your survey footer",
      "fillNext": "Fill (next)",
      "fillPrevious": "Fill (previous)",
      "fillSubmit": "Fill (Submit)",
      "textColor": "Button Text",
      "position": "Position",
      "positionTooltip": "Choose how the navigation buttons appear on your survey footer",
      "previousText": "Previous (text)",
      "nextText": "Next (text)",
      "submitText": "Submit (text)",
      "fillComplete": "Fill Complete",
      "fillInactive": "Fill Inactive",
      "footerType": "Footer Type",
      "stickToCard": "Stick to card",
      "stickToPage": "Stick to page",
      "stepTextColor": "Step Text Colour",
      "progressBarFill": "Progress bar Fill",
      "progressBarInactive": "Progress bar Inactive",
      "arrowFill": "Arrow Fill",
      "submitColorMobile": "Submit (Color)",
      "arrowFillColor": "Arrow Fill Color",
      "buttonTypes": {
        "textAndArrow": "Text & Arrow",
        "onlyText": "Only Text",
        "onlyArrow": "Only Arrow"
      },
      "positions": {
        "leftAndRight": "Left & Right"
      },
      "placeholders": {
        "prev": "Prev",
        "next": "Next",
        "submit": "Submit"
      }
    },
    "surveyNotfication": "Survey notification",
    "style": {
      "surveyPadding": "Survey Padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Survey",
      "share": {
        "openFormLink": "Open Survey Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your survey, or pick a template and embed it instantly."
      }
    },
    "autoResponderSubheader": "Send an automated email to the person who submits the survey (email includes a copy of the information they entered in the survey)",
    "sendSubmissionsAsPdf": "Send survey submission as a PDF",
    "switchToOneQuestionAtTimeOn": "Enabling 'One Question at a Time' disrupts your existing conditional logic",
    "switchToOneQuestionAtTimeOff": "Disabling 'One Question at a Time' impacts your conditional logic setup",
    "switchToOneQuestionAtTimeOnWarning": "Some conditions will no longer function as expected when questions are shown one at a time.",
    "switchToOneQuestionAtTimeOffWarning": " Some conditions designed for single-question flow will stop working as intended.",
    "createContactOnPartialSubmissionSubText": "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey.",
    "dragDrop": {
      "imageLabel": "Image {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Survey {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Privacy Policy</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Terms of Service</a></p>",
      "smsConsent": "I consent to receive SMS notifications, alerts & occasional marketing communication from company. Message frequency varies. Message & data rates may apply. Text HELP to (XXX) XXX-XXXX for assistance. You can reply STOP to unsubscribe at any time."
    }
  },
  "form": {
    "typeOfBuilder": "Form",
    "formStyle": "Form Style",
    "formElement": "Form Element",
    "addFormElement": "Add Form Element",
    "addConditionalLogic": "Add Conditional Logic",
    "openConditionalLogic": "Open Conditional Logic",
    "inlineForm": "Inline Form",
    "formName": "Form Name",
    "fullScreenMode": "Full Screen Mode",
    "fullScreenModetooltip": "Switching it on will cause the form to expand across the entire width of its container, stretching to the edge of the embedding area while adhering to the form's width.",
    "enableTimezoneForm": "Activating this option will capture the time zone information of the individual submitting the form",
    "formSettings": "Form Settings",
    "scheduleVisibility": {
      "title": "Schedule {product} visibility",
      "subtitle": "Set when this {product} should start and stop accepting responses. Outside this window, visitors will see the messages you configure below.",
      "formOpens": "{Product} opens",
      "formCloses": "{Product} closes",
      "rightAway": "Right away",
      "never": "Never",
      "pickADate": "Pick a date",
      "opensPlaceholder": "Opens as soon as you publish",
      "closesPlaceholder": "Stays open until you close it",
      "date": "Date",
      "time": "Time",
      "timezone": "Time zone",
      "timezoneHelp": "Applies to both the open and close times.",
      "timezonePlaceholder": "Select a time zone",
      "timeline": {
        "notOpenYet": "Not open yet",
        "acceptingResponses": "Accepting responses",
        "closed": "Closed",
        "current": "Current",
        "opens": "Opens",
        "closes": "Closes"
      },
      "whatVisitorsSee": "What visitors see",
      "whatVisitorsSeeHelp": "These pages only show outside the open window. Pick a state to set it up.",
      "states": {
        "beforeTitle": "Before the {product} opens",
        "afterTitle": "After the {product} closes",
        "showsPage": "Shows a custom page",
        "redirectsTo": "Redirects to {url}"
      },
      "showPage": "Show a page",
      "showPageHelp": "Design what visitors see.",
      "openLink": "Open a link",
      "openLinkHelp": "Send them to another URL.",
      "redirectUrl": "Redirect URL",
      "redirectUrlPlaceholder": "https://example.com",
      "redirectUrlHelp": "Visitors in this state are sent here instead of seeing a page. Use a full URL such as https://example.com/path.",
      "redirectUrlInvalid": "Enter a valid URL starting with http:// or https://, such as https://example.com/path.",
      "defaultBeforeMessage": "This {product} isn't open yet",
      "defaultAfterMessage": "This {product} is now closed",
      "defaultBeforeBody": "This {product} isn't accepting responses yet. Please check back once it opens to submit your response.",
      "defaultAfterBody": "Thanks for your interest! This {product} has stopped accepting responses. Reach out to the {product} owner if you still need to get in touch.",
      "closeAfterOpenError": "Close time must be after the open time.",
      "preview": {
        "label": "Preview",
        "labelHint": "— how visitors see it",
        "redirectTo": "You will be redirected to:",
        "poweredBy": "Powered by your agency"
      },
      "appearance": {
        "title": "Appearance",
        "cardBackground": "Card background",
        "pageBackground": "Page background",
        "cornerRadius": "Corner radius",
        "cardWidth": "Card width",
        "cardHeight": "Card height",
        "shadow": "Shadow",
        "autoPlaceholder": "Auto",
        "marginPadding": "Margin & padding",
        "auto": "auto",
        "miscellaneous": "Miscellaneous",
        "agencyBranding": "Agency branding",
        "agencyBrandingHelp": "Show your agency logo and name on the closed-state pages.",
        "shadowOptions": {
          "none": "None",
          "soft": "Soft",
          "elevated": "Elevated"
        },
        "colors": {
          "default": "Default",
          "lightGray": "Light gray",
          "brandTint": "Brand tint",
          "blush": "Blush",
          "dark": "Dark",
          "white": "White",
          "coolGray": "Cool gray"
        }
      }
    },
    "saveExitConfirmation": "Save progress for forms",
    "unsavedAlertMessage": "The form has unsaved work. Are you sure you want to leave and discard all unsaved work?",
    "thirdPartyScriptAlertMessage": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security, performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the form.",
    "onFormSubmission": "On Form Submission",
    "integrateForm": "Integrate Form",
    "embedlayoutType": "Embed Layout Type",
    "embedlayoutTypeSubMessage": "Select a layout to embed in a funnel or an external website",
    "triggerType": "Trigger type",
    "showOnScrolling": "Show on scrolling",
    "showAfter": "Show after",
    "seconds": "seconds",
    "alwaysShow": "Always show",
    "activationOptions": "Activation options",
    "activateOn": "Activate on",
    "visit": "visit",
    "alwaysActivated": "Always activated",
    "deactivationOptions": "Deactivation options",
    "deactivateAfterShowing": "Deactivate after showing",
    "times": "times",
    "deactiveOnceLeadCollected": "Deactivate once lead is collected",
    "neverDeactivate": "Never deactivate",
    "copyEmbedCode": "Copy embed code",
    "copyFormLink": "Copy form link",
    "openFormLink": "Open form link",
    "inline": "Inline",
    "inlineDescription": "An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.",
    "inlineHoverDescription": "An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.",
    "popup": "Popup",
    "popupDescription": "A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.",
    "popupHoverDescription": "A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.",
    "politeSlideIn": "Polite slide-in",
    "politeSlideInDescription": "A polite slide-in appears on the bottom side of screen and disappears once closed",
    "politeSlideInHoverDescription": "Appears on the bottom side of screen and disappears once closed",
    "stickySidebar": "Sticky sidebar",
    "stickySidebarDescription": "A Sticky sidebar will appear on the side of the screen and can be minimized to a tab that sticks to the side of the window",
    "stickySidebarHoverDescription": "Appear on the side of the screen and can be minimized to a tab that sticks to the side of the window",
    "allowMinimize": "Allow minimize",
    "checkForCookieConsent": "Respect host site cookie consent",
    "checkForCookieConsentTooltip": "Pixel events fire only after the visitor accepts marketing cookies on the site where this form is embedded. Auto-detect looks for GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi, and IAB TCF.",
    "cookieConsentProvider": "Cookie consent provider",
    "cookieConsentProviderPlaceholder": "Select your cookie consent banner",
    "cookieConsentProviderAutoDetect": "Auto-detect",
    "modalHeight": "Modal height",
    "modalHeightPlaceholder": "Enter modal height",
    "conditonalLogic": {
      "conditions": "Conditions",
      "noExistingCondition": "No existing conditions yet",
      "freeRoamMessage": "You're free to roam without the rules - at least for now",
      "addNewCondition": "Add New Condition",
      "redirectToUrl": "Redirect to URL",
      "displayCustomMessage": "Display custom message",
      "disqualifyLead": "Disqualify lead",
      "showHideFields": "Show/Hide Fields",
      "jumpTo": "Jump To",
      "redirectToUrlSubText": "Redirect users post-submission",
      "displayCustomMessageSubText": "Show messages based on user inputs",
      "disqualifyLeadSubText": "Filter out entries under specific conditions",
      "showHideFieldsSubText": "Adjust field visibility dynamically",
      "openBelowUrl": "Open below URL",
      "showCustomMessage": "Show custom message",
      "alertConditionDelete": "Are you sure you want to delete this condition?",
      "deleteCondition": "Delete Condition",
      "conditionExecutedMessage": "Conditions will be executed from top-down order.",
      "anyVariant": "Any variant",
      "bumpSuffix": "Order Bump",
      "untitledProduct": "Untitled product",
      "deletedProduct": "Deleted product",
      "deletedVariant": "Deleted variant",
      "allOperationOptions": {
        "isEqualTo": "Is Equal To",
        "isNotEqualTo": "Is Not Equal To",
        "contains": "Contains",
        "doesNotContain": "Does Not Contain",
        "startsWith": "Starts With",
        "endsWith": "Ends With",
        "isEmpty": "Is Empty",
        "isFilled": "Is Filled",
        "before": "Before",
        "after": "After",
        "greaterThan": "Greater Than",
        "lessThan": "Less Than",
        "between": "Between",
        "isChecked": "Is Checked",
        "isNotChecked": "Is Not Checked",
        "isSelected": "Is selected",
        "isNotSelected": "Is not selected",
        "pricingOptionIs": "Pricing option is",
        "pricingOptionIsNot": "Pricing option is not"
      },
      "logic": {
        "if": "If",
        "then": "Then",
        "and": "And",
        "or": "Or"
      },
      "phoneAlertMessage": "To search for phone numbers with a country code, you need to explicitly include the '+' symbol in your search query.",
      "deleteAlertMessage": "Are you sure you want to delete this field? The condition associated with this field will also be removed.",
      "deleteField": "Delete Field",
      "jumpToDescription": "Jump to a specific slide when conditions are met",
      "cycleError": "Cannot Save. Cycle detected between {a} and {b}",
      "jumpToSlide": "Jump To Slide",
      "submitSurvey": "Submit Survey",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Select slide to jump from",
      "selectedSlide": "Selected slide",
      "typeValueHere": "Please Type a value here",
      "field": "Field",
      "slide": "Slide",
      "selectFieldOrSlide": "Select Field or Slide",
      "selectFieldState": "Select Field State",
      "selectField": "Select field",
      "quizFields": "Quiz Fields",
      "standardFields": "Standard Fields",
      "highestScore": "Highest Score",
      "lowestScore": "Lowest Score",
      "overallScore": "Overall Score",
      "categoryScore": "Category Score",
      "selectCategory": "Select Category",
      "scoreFormat": "Score Format",
      "percentage": "Percentage",
      "actualScore": "Actual Score",
      "outOf10": "Out of 10",
      "selectOption": "Select Option",
      "jumpToTarget": "Jump To",
      "jumpToQuestion": "Jump To Question",
      "chooseQuestion": "Choose Question",
      "includeStart": "Include start",
      "includeEnd": "Include end",
      "includeValue": "Include {value}",
      "hideField": "Hide Field",
      "hideFields": "Hide Fields",
      "showField": "Show Field",
      "showFields": "Show Fields",
      "additionalRulesPrefix": "...and",
      "additionalRulesSuffix": "other {ifLabel} rules ...",
      "shownTargetsWithMore": "{shown}, +{count} more",
      "noConditionsAlt": "No conditions yet",
      "outcomeLabels": {
        "show": "Show",
        "jumpTo": "Jump To"
      },
      "entireSection": "Entire section",
      "specificProducts": "Specific products",
      "mainProduct": "Main Product",
      "bumpProduct": "Bump Product",
      "searchProductsOrVariants": "Search products or variants",
      "selectAll": "Select all",
      "clear": "Clear",
      "variantsCount": "{count} variants",
      "productsSelectedCount": "{selected} of {total} products",
      "selectAtLeastOneProduct": "Select at least 1 product or variant.",
      "productHint": {
        "entireHide": "The whole {section} section is hidden when the condition is met.",
        "entireShow": "The whole {section} section stays hidden until the condition is met.",
        "specificHide": "Selected items are hidden when the condition is met.",
        "specificShow": "Selected items stay hidden until the condition is met.",
        "allSelectedHide": "Every product is selected, so the whole section will be hidden.",
        "allSelectedShow": "Every product is selected, so the whole section stays hidden until the condition is met."
      },
      "productsCountShort": "{count} products",
      "noProductsMatchSearch": "No products match that search.",
      "noProductsTitle": "No products in this field yet",
      "noProductsBody": "Add products to {section} to show or hide them one by one. You can still hide the entire section.",
      "remove": "Remove",
      "deletedProductTitleOne": "1 product no longer exists",
      "deletedProductTitleOther": "{count} products no longer exist",
      "deletedProductBodyOne": "A selected product was removed from {section}. Remove it from this condition to save.",
      "deletedProductBodyOther": "Selected products were removed from {section}. Remove them from this condition to save.",
      "selectPricingOption": "Select pricing option",
      "selectProduct": "Select product"
    },
    "minimizedTitlePlaceholder": "Minimized title",
    "dragYourElementFromLeft": "Drag your elements here from the left",
    "formNotification": "Form notification",
    "sendSubmissionsAsPdf": "Send form submission as a PDF",
    "style": {
      "formPadding": "Form Padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Form",
      "share": {
        "openFormLink": "Open Form Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your form, or pick a template and embed it instantly."
      }
    },
    "choosePosition": "Choose Position",
    "testBuild": "Test Build"
  },
  "quiz": {
    "quizElement": "Quiz Element",
    "quizNotification": "Quiz notification",
    "viewAndCustomise": "View And Customise",
    "categoryAndScore": "Category and Score",
    "provideFeedback": "Provide feedback",
    "addQuizElement": "Add Quiz Element",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Add Questions",
    "dragAndDropQuestion": "Drag and drop a Question Element here.",
    "addNewPage": "Add Page",
    "editTemplate": "Edit Template",
    "editResultPage": "Edit Result Page",
    "clonePage": "Clone Page",
    "category": {
      "category": "Category",
      "useCategoryWhen": "Use Categories When",
      "manageCategories": "Manage Categories",
      "howItWorks2": "How Does This Work",
      "addCategoryMessage": "Add a new category",
      "assignCategoryMessage": "Assign a category to each option",
      "editResultsMessage": "Show category score in result page",
      "toEvaluateTheResponder": "To evaluate the responder based on several factors",
      "showMultipleCategoryScore": "Show multiple category score in result page",
      "displayVaryingContent": "Display varying content on the results page depending on the category score tier",
      "addManage": "Add / Manage",
      "carouselAlt": "Category preview slide"
    },
    "quizSettings": "Quiz Settings",
    "saveExitConfirmation": "Save progress for quizzes",
    "onQuizSubmission": "On Quiz Submission",
    "settings": "Settings",
    "deletePage": "Delete Page",
    "quizResult": {
      "resultTemplate": "Result Page Template",
      "quizResultAlertMessage": "The chosen result page will be shown once the quiz is completed",
      "overallScoreLabel": "Overall score",
      "resultTemplateAlt": "Quiz result template preview"
    },
    "deleteSlideMessage": "Are you sure you want to delete this slide?",
    "autoResponderSubheader": "Send an automated email to the person who submits the quiz (email includes a copy of the information they entered in the quiz)",
    "sendSubmissionsAsPdf": "Send quiz submission as a PDF",
    "sendQuizResultsAsPdf": "Send quiz result as a PDF",
    "integrateHeader": "Integrate Quiz",
    "integrateSubHeader": "Use the following options to integrate your custom quiz into your website",
    "integrateCopyLinkMessage": "Copy the link below and easily share it anywhere you wish.",
    "pageLabel": "Page {n}",
    "pageName": "Page Name",
    "pagePosition": "Page Position",
    "createContactOnPartialSubmissionSubText": "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Quiz",
      "share": {
        "openFormLink": "Open Quiz Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your quiz, or pick a template and embed it instantly."
      }
    }
  },
  "integrate": {
    "embed": {
      "chooseType": "Choose type",
      "sidebar": "Sidebar",
      "popover": "Popover",
      "popup": "Popup",
      "standard": "Standard",
      "formWidth": "Form width",
      "formHeight": "Form height",
      "showLauncher": "Show {asset} button",
      "showLauncherHelp": "Visitors can minimize and reopen the {asset} anytime.",
      "position": "Choose position",
      "left": "Left",
      "right": "Right",
      "buttonLabel": "Button label",
      "buttonColor": "Button color",
      "buttonType": "Button type",
      "buttonSize": "Button size",
      "text": "Text",
      "iconAndText": "Icon + text",
      "iconOnly": "Icon only",
      "small": "Small",
      "medium": "Medium",
      "large": "Large",
      "icon": "Icon",
      "cornerRadius": "Corner radius",
      "linkCornerRadius": "Link corner radius values",
      "corner": {
        "tl": "Top-left corner radius",
        "tr": "Top-right corner radius",
        "bl": "Bottom-left corner radius",
        "br": "Bottom-right corner radius"
      },
      "fontSize": "Font size",
      "embedIn": "Embed in",
      "funnels": "Funnels",
      "websites": "Websites",
      "settingsTitle": "Embed settings",
      "preview": "Preview",
      "previewHint": "Hit the button to see your {type} in action",
      "realPreviewTitle": "Preview of your {asset}",
      "realPreviewUnavailable": "Live preview unavailable. Showing a sample instead.",
      "ghostName": "Name",
      "ghostNamePlaceholder": "Enter your name",
      "ghostPhone": "Phone number",
      "ghostPhonePlaceholder": "+1 (555) 123-4567",
      "ghostEmail": "Email address",
      "ghostEmailPlaceholder": "example{'@'}gmail.com",
      "ghostSubmit": "Submit",
      "sidebarLower": "sidebar",
      "popoverLower": "popover",
      "popupLower": "popup",
      "standardLower": "standard form",
      "general": "General",
      "advanced": "Advanced",
      "embedCode": "Embed code",
      "triggerType": "Trigger type",
      "alwaysShow": "Always show",
      "showAfter": "Show after",
      "showOnScrolling": "Show on scrolling",
      "activation": "Activation options",
      "alwaysActivated": "Always activated",
      "activateOnVisit": "Activate on visit",
      "deactivation": "Deactivation options",
      "neverDeactivate": "Never deactivate",
      "deactivateAfter": "Deactivate after showing",
      "leadCollected": "Once a lead is collected",
      "modalTitle": "Embed in webpage",
      "copyStep": "Copy the embed code",
      "openWebpageStep": "Open your webpage",
      "openWebpageStepHelp": "Open the page editor and find the option to add HTML or custom code.",
      "publishStep": "Paste the code and publish",
      "publishStepHelp": "Paste the embed code into your HTML or custom code section, then save and publish your page.",
      "copyCode": "Copy code",
      "setupGuidePrompt": "Using WordPress, Wix or Webflow?",
      "viewSetupGuides": "View setup guides"
    },
    "postSave": {
      "title": "Your {asset} is ready",
      "description": "Share it, embed it, or connect a workflow whenever you're ready.",
      "embedForm": "Embed {asset}",
      "connect": "Connect",
      "createWorkflow": "Create a Workflow",
      "workflowDescription": "Run a workflow on every submission.",
      "dontShowAgain": "Don’t show this again"
    },
    "email": {
      "preview": "Preview",
      "shareViaEmail": "Share via email",
      "startFromScratch": "Start from scratch",
      "emailMarketingTemplates": "Email marketing templates",
      "templateImageAlt": "2000+ email templates",
      "yourTemplates": "Your templates",
      "selectTemplate": "Select from your templates",
      "to": "To:",
      "from": "From:",
      "inviteTitle": "Hi there,",
      "inviteBody": "I've invited you to fill out a form:",
      "inviteAction": "Fill out our form"
    },
    "share": {
      "copyLink": "Share link",
      "copyLinkTitle": "Copy the link to your {asset}",
      "copyLinkDescription": "Start collecting submissions for your {asset}. Either you want to share the link or embed it somewhere, we've got you covered.",
      "copyLinkButton": "Copy link",
      "openLink": "Open link",
      "shareOnSocialMedia": "Share on social media",
      "socialDescription": "Easily share your {asset} on preferred social media platforms and start collecting submissions.",
      "qrCode": "QR code",
      "shareQr": "Share QR",
      "shareQrDescription": "Scan or share this QR to access your {asset} instantly.",
      "qrLoading": "Loading QR code...",
      "qrLoadError": "QR code couldn't load. Please try again.",
      "preview": "Preview",
      "social": {
        "facebook": "Share on Facebook",
        "whatsapp": "Share on WhatsApp",
        "linkedin": "Share on LinkedIn",
        "x": "Share on X"
      }
    }
  },
  "textEditor": {
    "textAlign": "Text align",
    "list": "List",
    "sourceCode": "Source Code",
    "resetStyle": "Reset style",
    "resetDocumentStyle": "Reset document style"
  },
  "builderValidation": {
    "ui": {
      "checking": "Checking",
      "actionRequired": "Action required",
      "errorSummary": "{n} error(s) needs to be fixed before you can save. Select it to jump to the error.",
      "viewErrors": "View errors",
      "panelTitle": "Recommendations ({n})",
      "panelSubtitle": "Optional tips to improve your {product}. Save anytime.",
      "tabRecommendations": "Recommendations",
      "tabInsights": "Insights",
      "recommendationsPill": "Recommendations",
      "noRecommendationsTitle": "Nothing to review",
      "noRecommendationsBody": "This {product} has no recommendations. You're ready to save.",
      "settingTitle": "Show {product} recommendations",
      "settingDescription": "Get smart recommendations to catch overlooked mistakes, improve your {product}, and drive more submissions",
      "dontShowAgain": "Don't show again",
      "allClearTitle": "All clear",
      "allClearBody": "Everything is fixed. You're ready to save.",
      "openInsight": "Open {name} settings",
      "dontShowAgainHint": "Form Recommendations will be turned off, but you can enable them anytime from the Settings tab.",
      "panelLabel": "Recommendations",
      "done": "Done",
      "errorSummaryOne": "1 error. You can't save until it's fixed. Select it to jump to it."
    },
    "errors": {
      "urlFieldDomainsMissing": "A URL field restricts domains but none are listed.",
      "pictureChoiceImageMissing": "A picture choice option has no image.",
      "pictureChoiceLabelMissing": "A picture choice option has no label.",
      "pictureChoiceDuplicateLabels": "Two picture choice options share a label.",
      "pictureChoiceSelectionLimitInvalid": "A picture choice selection limit is higher than the number of options.",
      "datetimeLabelEmpty": "A date & time field has no label.",
      "datetimeTimeFormatInvalid": "A date & time field has an invalid default time.",
      "datetimeNoAvailableDays": "A date & time field has no days available to pick.",
      "datetimeDateRangeInvalid": "A date & time field has an incomplete or reversed date range.",
      "datetimeTimeRangeInvalid": "A date & time field has an incomplete or reversed time range.",
      "opportunitySettingsIncomplete": "This form collects opportunity fields but has no pipeline stage set.",
      "footerStylesInvalid": "The footer settings are incomplete.",
      "sellProductsNoProduct": "A product element has no products or bump products.",
      "imageMissing": "An image element has no image.",
      "scoreCalculationEmpty": "A score element has no fields in its calculation.",
      "customFieldLabelRequired": "Give this field a name before saving it as a custom field.",
      "customFieldNameTaken": "\"{label}\" uses a name another custom field already has. Rename it.",
      "customFieldSaveFailed": "This field couldn't be saved: {message}",
      "duplicateCustomFieldName": "Two fields share the label \"{name}.\"",
      "emptyCustomFieldLabel": "A custom field has no label."
    },
    "errorsInline": {
      "urlFieldDomainsMissing": "No domains added",
      "pictureChoiceImageMissing": "No image added",
      "pictureChoiceLabelMissing": "Missing label",
      "pictureChoiceDuplicateLabels": "Duplicate label",
      "pictureChoiceSelectionLimitInvalid": "Invalid selection limit",
      "datetimeLabelEmpty": "Missing label",
      "datetimeTimeFormatInvalid": "Invalid time",
      "datetimeNoAvailableDays": "No days selected",
      "datetimeDateRangeInvalid": "Invalid date range",
      "datetimeTimeRangeInvalid": "Invalid time range",
      "opportunitySettingsIncomplete": "Pipeline stage missing",
      "footerStylesInvalid": "Footer settings incomplete",
      "sellProductsNoProduct": "No products added",
      "imageMissing": "No image added",
      "scoreCalculationEmpty": "No fields added",
      "customFieldLabelRequired": "Name required",
      "customFieldNameTaken": "Name already used",
      "customFieldSaveFailed": "Couldn't save",
      "duplicateCustomFieldName": "Duplicate label",
      "emptyCustomFieldLabel": "Missing label"
    },
    "errorsAction": {
      "urlFieldDomainsMissing": "Add a domain",
      "pictureChoiceImageMissing": "Add image",
      "pictureChoiceLabelMissing": "Add a label",
      "pictureChoiceDuplicateLabels": "Rename duplicate label",
      "pictureChoiceSelectionLimitInvalid": "Fix selection limit",
      "datetimeLabelEmpty": "Add a label",
      "datetimeTimeFormatInvalid": "Fix default time",
      "datetimeNoAvailableDays": "Select available days",
      "datetimeDateRangeInvalid": "Fix date range",
      "datetimeTimeRangeInvalid": "Fix time range",
      "opportunitySettingsIncomplete": "Open opportunity settings",
      "footerStylesInvalid": "Open footer settings",
      "sellProductsNoProduct": "Add products",
      "imageMissing": "Add image",
      "scoreCalculationEmpty": "Add fields",
      "customFieldLabelRequired": "Name the field",
      "customFieldNameTaken": "Rename the field",
      "customFieldSaveFailed": "Open the field",
      "duplicateCustomFieldName": "Rename duplicate label",
      "emptyCustomFieldLabel": "Add a label"
    },
    "recommendations": {
      "termsConditionsMissing": "Collect consent before you store visitor data.",
      "captchaMissing": "Protect this form from spam submissions.",
      "privacyPolicyUrlMissing": "The consent text still links to example.com.",
      "sellProductsNotLive": "Payment is in test mode, so no money will be collected.",
      "defaultCustomFieldName": "Default labels make submissions hard to read.",
      "emptyCustomFieldLabelExisting": "A field has no label, so visitors will not know what to enter.",
      "quizOptionPlaceholder": "Answers in \"{label}\" still use the default option names.",
      "quizScoreBlank": "An answer has no score, so it will not count towards a result.",
      "quizCtaUrlPlaceholder": "The results page button still links to example.com.",
      "headerTextEmpty": "A text element is empty.",
      "htmlElementEmpty": "An HTML element has no content.",
      "buttonTextEmpty": "The submit button has no text.",
      "sourceFieldValueEmpty": "A hidden source field has no value, so nothing is tracked.",
      "optionLabelEmpty": "An answer option has no label.",
      "fileUploadMaxSizeInvalid": "The file upload limit is not a valid number.",
      "submitRedirectUrlMissing": "Submissions redirect somewhere, but no address is set.",
      "submitRedirectUrlInvalid": "The redirect address after submit is not a valid URL.",
      "disqualifyUrlMissing": "Disqualified visitors are redirected, but no address is set.",
      "disqualifyMessageEmpty": "Disqualified visitors are shown a blank message.",
      "scheduleRedirectUrlInvalid": "A scheduled redirect address is not a valid URL.",
      "scheduleNoClosedStateContent": "A scheduled state shows visitors nothing.",
      "notificationRecipientMissing": "Email notifications are on with no one to send to.",
      "notificationEmailInvalid": "A notification recipient is not a valid email address.",
      "logicOrphanFieldReference": "A logic rule points at a field that no longer exists, so it never runs.",
      "logicOrphanOptionReference": "A logic rule points at an answer option that no longer exists.",
      "logicOrphanTarget": "A logic rule jumps to a page that no longer exists.",
      "scoreCalculationInvalidReference": "A score calculation uses a field that no longer exists.",
      "assetHasNoElements": "No questions have been added yet, so there is nothing to collect.",
      "quizCtaUrlMissing": "The results page button has no destination.",
      "termsConditionsHidden": "Your terms and conditions are hidden, so visitors never see them."
    },
    "recommendationsAction": {
      "termsConditionsMissing": "Add terms and conditions field",
      "captchaMissing": "Add bot protection",
      "privacyPolicyUrlMissing": "Update the links",
      "sellProductsNotLive": "Turn on live mode",
      "defaultCustomFieldName": "Rename \"{label}\"",
      "emptyCustomFieldLabelExisting": "Add a label",
      "quizOptionPlaceholder": "Rename the options",
      "quizScoreBlank": "Add a score",
      "quizCtaUrlPlaceholder": "Update the link",
      "headerTextEmpty": "Add text",
      "htmlElementEmpty": "Add content",
      "buttonTextEmpty": "Add button text",
      "sourceFieldValueEmpty": "Add a value",
      "optionLabelEmpty": "Add a label",
      "fileUploadMaxSizeInvalid": "Set a limit",
      "submitRedirectUrlMissing": "Add a redirect URL",
      "submitRedirectUrlInvalid": "Fix the redirect URL",
      "disqualifyUrlMissing": "Add a redirect URL",
      "disqualifyMessageEmpty": "Add a message",
      "scheduleRedirectUrlInvalid": "Fix the redirect URL",
      "scheduleNoClosedStateContent": "Add content",
      "notificationRecipientMissing": "Add a recipient",
      "notificationEmailInvalid": "Fix the address",
      "logicOrphanFieldReference": "Review logic",
      "logicOrphanOptionReference": "Review logic",
      "logicOrphanTarget": "Review logic",
      "scoreCalculationInvalidReference": "Fix the calculation",
      "assetHasNoElements": "Add your first question",
      "quizCtaUrlMissing": "Add a link",
      "termsConditionsHidden": "Show the field"
    },
    "insights": {
      "heading": "Your form setup at a glance.",
      "conditionalLogic": "Conditional logic",
      "submitDestination": "On-submit action",
      "customFields": "Custom fields",
      "paymentMode": "Payment mode",
      "emailNotification": "Email notification",
      "autoResponder": "Auto responder",
      "quizCategories": "Quiz categories",
      "ruleCount": "{n} rules",
      "on": "On",
      "off": "Off",
      "live": "Live",
      "test": "Test",
      "destinationUrl": "Redirect URL",
      "destinationMessage": "Message",
      "destinationOrder": "Order confirmation",
      "destinationQuizResult": "Quiz result"
    },
    "groups": {
      "fields": "Fields",
      "questions": "Questions",
      "questionsPage": "Questions Page",
      "resultsPage": "Results Page",
      "payments": "Payments",
      "settings": "Settings"
    }
  }
}
